export default __webpack_public_path__ + "media/images/gift_fund/giftfund_logo-496cea50c5df057caff89307703c73b7.png";